import React from 'react';
import LanguageDropdown from './LanguageDropdown';
import ShoppingCart from './ShoppingCart';
import CurrencyDropdown from './CurrencyDropdown';
import langConf from "../js/lang";



class TopMenu extends React.Component {

    onItemsClick = (event) => {
        event.preventDefault();

        this.props.changeScreen('items');
    }

    render() {
        let lang = this.props.lang;
        let currURL = this.props.currentURL;
        return (
            <div className="col-12">
                
                <div className="col-12">
                    <img src={lang === 'hebrew' ? this.props.vendorData.logoUrlHeb : this.props.vendorData.logoUrlEng} alt="logo" />
                </div>
                <div className="col-12">
                <LanguageDropdown
                        lang={lang}
                        // Methods 
                        changeLanguage={this.props.changeLanguage}
                    />
                    <CurrencyDropdown
                        lang={lang}
                        currency={this.props.currency}
                        changeCurrency={this.props.changeCurrency}
                    />
                    <ShoppingCart
                        allItems={this.props.allItems}
                        includeBidItems={this.props.includeBidItems}
                        bidItems={this.props.bidItems}
                        changeScreen={this.props.changeScreen}
                        lang={lang}
                        defaultVal={this.props.defaultVal}
                    />
                    <div className='col-3 col-xs-6'>
                        <a className={`btn btn-default btn-block items-button ${lang === 'hebrew' ? 'hebrew' : 'english'}`} onClick={this.onItemsClick} href={currURL}>{langConf[lang].items}</a>
                    </div>
                </div>

            </div>
        );
    }
}

export default TopMenu;
